import { render, staticRenderFns } from "./EdicionesHeader.vue?vue&type=template&id=60900b38"
import script from "./EdicionesHeader.vue?vue&type=script&lang=js"
export * from "./EdicionesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports